


import RouteG from "./Routes/RouteG"
const App = () => {
  return (
 
  <RouteG  />
  );
};

export default App;
